/**
 * @generated SignedSource<<7b6ae9aba68efb0468cb9a49e7da71ce>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AddKitMemberInput = {
  assetTag: any;
  clientMutationId?: string | null | undefined;
  kitId: string;
};
export type OpsKitPageAddMemberMutation$variables = {
  input: AddKitMemberInput;
};
export type OpsKitPageAddMemberMutation$data = {
  readonly addKitMember: {
    readonly kit: {
      readonly id: string;
    } | null | undefined;
    readonly userErrors: ReadonlyArray<{
      readonly message: string;
    }>;
  } | null | undefined;
};
export type OpsKitPageAddMemberMutation = {
  response: OpsKitPageAddMemberMutation$data;
  variables: OpsKitPageAddMemberMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "AddKitMemberPayload",
    "kind": "LinkedField",
    "name": "addKitMember",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Asset",
        "kind": "LinkedField",
        "name": "kit",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "UserError",
        "kind": "LinkedField",
        "name": "userErrors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "OpsKitPageAddMemberMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "OpsKitPageAddMemberMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "6e0dd900fa5539cb7a802d19364dc7b3",
    "id": null,
    "metadata": {},
    "name": "OpsKitPageAddMemberMutation",
    "operationKind": "mutation",
    "text": "mutation OpsKitPageAddMemberMutation(\n  $input: AddKitMemberInput!\n) {\n  addKitMember(input: $input) {\n    kit {\n      id\n    }\n    userErrors {\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "aef41bd1f725ffd7f1895111f90a2e4b";

export default node;
